import { buildPublicUrlLink } from 'src/utils/buildPublicUrlLink';
import { intl } from 'src/config/intl/intl';

export const statuteAndPrivacyPolicyConsentId = 'statute_and_privacy_policy';

export const statuteAndPrivacyPolicyConsent = {
  id: statuteAndPrivacyPolicyConsentId,
  code: statuteAndPrivacyPolicyConsentId,
  mandatory: true,
  label: (
    <>
      {intl.formatMessage(
        { id: 'main.consents.statuteAndPrivacyPolicy' },
        {
          statuteLink: (str) =>
            (
              <strong>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={buildPublicUrlLink('docs/AISGateway_regulamin.pdf')}
                >
                  {str}
                </a>
              </strong>
            ) as any,
          privacyPolicyLink: (str) =>
            (
              <strong>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={buildPublicUrlLink('docs/AIS_Polityka_prywatności.pdf')}
                >
                  {str}
                </a>
              </strong>
            ) as any,
        }
      )}
    </>
  ),
};
